import React, { useState, createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const UniversalHeaderSearchContext = /*#__PURE__*/createContext({
  showSearch: false,
  setShowSearch: () => {
    // no-op
  },
  specialSearchKind: undefined
});
export const UniversalHeaderSearchContextProvider = _ref => {
  let {
    children
  } = _ref;
  const {
    0: showSearch,
    1: setIsVisible
  } = useState(false);
  const {
    0: specialSearchKind,
    1: setSpecialSearchKind
  } = useState(undefined);
  const setShowSearch = (isVisible, kind) => {
    if (!isVisible) {
      setSpecialSearchKind(undefined);
    } else {
      setSpecialSearchKind(kind);
    }
    setIsVisible(isVisible);
  };
  return /*#__PURE__*/_jsx(UniversalHeaderSearchContext.Provider, {
    value: {
      showSearch,
      setShowSearch,
      specialSearchKind
    },
    children: children
  });
};
export const useUniversalHeaderSearch = () => useContext(UniversalHeaderSearchContext);